import { Icon } from 'src/components'
import styled from 'styled-components'

export const CustomIcon = styled(Icon)`
  width: 1.25rem;
  height: 1.25rem;
`

CustomIcon.displayName = 'CustomPostLeaveIcon'

export const ConfirmLeaveButton = styled.button`
  border-radius: 0.375rem;
`

ConfirmLeaveButton.displayName = 'ConfirmLeaveButton'
